import { Avatar, AvatarImage } from '../ui/avatar';

interface Props {
  avatar: string;
  name: string;
  role: string;
  desc?: string;
}

export const BureauMemberCard = ({ avatar, name, role, desc }: Props): JSX.Element => {
  return (
    <div className="flex flex-col items-center h-full p-6 text-center transition-all duration-300 bg-white border border-gray-200 shadow-sm rounded-xl hover:shadow-lg hover:-translate-y-1">
      <Avatar className="w-20 h-20 mb-4 ring-4 ring-primary/10">
        <AvatarImage alt={name} src={avatar} className="object-cover object-top" />
      </Avatar>
      <h3 className="text-sm font-semibold text-gray-900">{name}</h3>
      <span className="inline-block px-3 py-1 mt-2 text-xs font-semibold rounded-full bg-primary/10 text-primary">
        {role}
      </span>
      {desc && <p className="mt-3 text-sm leading-relaxed text-gray-500">{desc}</p>}
    </div>
  );
};
